<div class="card border-0 shadow-sm mb-4">
    <div class="card-body">
        <h4 class="mb-4 text-secondary">{{ title }}</h4>
        <div class="row align-items-center">
            <div class="col-lg-8">
                <div class="d-flex flex-column flex-lg-row align-items-center justify-content-center">
                    <dx-pie-chart
                        type="doughnut"
                        [dataSource]="chartSlices"
                        [innerRadius]="0.7"
                        centerTemplate="centerTemplate"
                        [customizePoint]="color"
                        (onInitialized)="onChartInitialized($event)"
                    >
                        <dxo-pie-chart-size [height]="300"></dxo-pie-chart-size>
                        <dxi-series argumentField="argument" valueField="value">
                            <dxo-label [visible]="false"></dxo-label>
                        </dxi-series>
                        <dxo-tooltip [enabled]="hasData" [customizeTooltip]="customizeTooltip"></dxo-tooltip>
                        <dxo-legend [visible]="false"></dxo-legend>
                        <svg *dxTemplate="let pie of 'centerTemplate'">
                            <text text-anchor="middle" style="font-size: 34px; fill: currentColor;" x="100" y="115">
                                <tspan x="100" dy="0">{{ centerLabel }}</tspan>
                                <tspan class="text-body-secondary" x="100" dy="24" style="font-size: 14px; fill: currentColor;">{{ centerText }}</tspan>
                            </text>
                        </svg>
                    </dx-pie-chart>

                    <div class="d-flex flex-column ms-lg-4 mt-3 mt-lg-0 gap-2">
                        @for (slice of slices; track slice.argument) {
                            <span class="d-inline-flex align-items-center"
                                  style="cursor: pointer;"
                                  [class.opacity-50]="hiddenArguments.has(slice.argument)"
                                  (click)="onLegendClick(slice.argument)"
                                  (mouseenter)="onLegendHover(slice.argument, true)"
                                  (mouseleave)="onLegendHover(slice.argument, false)">
                                <span class="rounded-circle me-2 flex-shrink-0"
                                      style="width: 12px; height: 12px;"
                                      [style.background]="palette[slice.argument]"></span>
                                <small class="text-body-secondary"
                                       [class.text-decoration-line-through]="hiddenArguments.has(slice.argument)">{{ slice.argument }}</small>
                            </span>
                        }
                    </div>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="table-responsive rounded-1 border border-1">
                    <table class="table table-borderless mb-0">
                        <thead class="bg-light text-muted small text-uppercase">
                            <tr class="table-light">
                                <th>Type</th>
                                <th>{{ valueHeader }}</th>
                                @if (showPercent) {
                                    <th>%</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (slice of slices; track slice.argument) {
                                <tr class="border-top">
                                    <td class="text-muted">{{ slice.argument }}</td>
                                    <td class="text-muted">{{ slice.value }}</td>
                                    @if (showPercent) {
                                        <td class="text-muted">{{ percent(slice) | number: '1.2-2' }}%</td>
                                    }
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
